import showcase1 from './../assets/images/Weddings/Showcase/showcase1.webp';
import showcase2 from './../assets/images/Weddings/Showcase/showcase2.webp';
import showcase3 from './../assets/images/Weddings/Showcase/showcase3.webp';
import showcase4 from './../assets/images/Weddings/Showcase/showcase4.webp';
import showcase5 from './../assets/images/Weddings/Showcase/showcase5.webp';
import rosesSplitter from './../assets/images/Splitters/rosesSplitter.webp'

const WeddingShowcase = () => {
  return (
    <div className='max-w-[1600px] m-auto py-16 px-8 bg-[#F7E7CE] rounded-2xl shadow-xl'>
      <div className='text-center mb-12'>
        <h3 className='text-4xl md:text-5xl font-extrabold leading-tight text-[#D2B48C]'>Your wedding, Your way</h3>
        <p className='text-2xl py-6 leading-relaxed text-gray-700'>At The Fox, we have a dedicated Wedding Executive to help you plan a wedding that is perfect for you, ensuring a flawless experience from start to finish for you and your guests.
        </p>
      </div>

      <div className='grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6'>
        <img className='object-cover w-full h-[400px] rounded-lg shadow-md' src={showcase1} alt="Function Aisle" />
        <img className='object-cover w-full h-[400px] rounded-lg shadow-md' src={showcase2} alt="Function Room" />
        <img className='object-cover w-full h-[400px] rounded-lg shadow-md' src={showcase3} alt="Function Aisle" />
      </div>

      <div className='flex justify-center pb-6'>
          <img src={rosesSplitter} alt="fox divider" className='w-[200px]' />
      </div>

      <div className='grid lg:grid-cols-2 gap-8 mb-12'>
        <img className='object-cover w-full h-[300px] rounded-lg shadow-md' src={showcase4} alt="The Garden" />
        <div className='flex flex-col justify-center'>
          <h3 className='text-3xl font-bold text-[#D2B48C]'>Our Grounds</h3>
          <p className='text-lg leading-relaxed text-gray-600 mt-4'>
          As a charming, family-run venue nestled in a breathtaking rural setting, we offer the perfect backdrop for
          unforgettable civil ceremonies and wedding receptions. Our picturesque grounds provide a serene and romantic 
          atmosphere, making every moment truly special. Below, you'll find details of our carefully curated wedding 
          ackages, designed to suit a variety of styles and preferences. For those seeking a more personalized touch, 
          we specialize in bespoke weddings, ensuring every detail is tailored to your vision. With our versatile venue 
          and dedicated team, we are committed to creating a magical and seamless experience that reflects your unique 
          love story.
          </p>
        </div>
      </div>

      <div className='grid lg:grid-cols-2 gap-8'>
        <div className='flex flex-col justify-center'>
          <h3 className='text-3xl font-bold text-[#D2B48C]'>Choosing the Right Partners</h3>
          <p className='text-lg leading-relaxed text-gray-600 mt-4'>
          Choosing the right partners for your wedding extras is essential to making your day as perfect as possible. 
          Working with professional and reliable local suppliers ensures high-quality service and attention to detail. 
          From stunning event décor and beautiful balloon arrangements to expert photography and videography, selecting 
          rusted vendors who are experienced and well-regarded can make all the difference. Partnering with those who 
          are regularly recommended and offer preferential rates can help bring your vision to life seamlessly, creating 
          a memorable and stress-free celebration.
          </p>
        </div>
        <img className='object-cover w-full h-[300px] rounded-lg shadow-md' src={showcase5} alt="Bride & Groom" />
      </div>
    </div>
  );
}

export default WeddingShowcase;